import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'
import type { Member } from '@/types/inbox'

type ApiMember = {
  id: string
  user?: {
    id: string
    name: string | null
    email: string
    image?: string | null
  }
  departmentMemberships?: { departmentId: string }[]
}

export function useInboxMembers(orgId: string | null) {
  return useQuery({
    queryKey: ['inbox-members', orgId],
    queryFn: async () => {
      const res = await api.get<{ data: ApiMember[] }>(
        `/orgs/${orgId}/members`,
        {
          params: { limit: 100 },
        }
      )
      return res.data.data.map(
        (member): Member => ({
          id: member.user?.id ?? member.id,
          name: member.user?.name ?? null,
          email: member.user?.email ?? '',
          image: member.user?.image ?? null,
          departmentIds: (member.departmentMemberships ?? []).map(
            (d) => d.departmentId
          ),
        })
      )
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  })
}
